import { cn } from '../../lib'
import type { ChipV2Props } from './chip-v2.types'

import { chipV2Style } from './chip-v2.css'

/**
 * @deprecated Use Chip instead
 */
const ChipV2 = ({ className, children, selected, fontWeight = 'bold', direction, ...props }: ChipV2Props) => {
  return (
    <button
      {...props}
      className={cn([`font-${fontWeight}`], chipV2Style({ direction }), className)}
      data-selected={selected ? 'selected' : 'un-selected'}
      aria-selected={selected}
    >
      {children}
    </button>
  )
}

ChipV2.displayName = 'ChipV2'

export default ChipV2
